import { BASE_URL } from "../../util/Constants";
import HTTP from "../../util/Http";

export let GRUPOS = [];
fetchGrupos(fetchGrupos);

async function fetchGrupos() {
  const url = BASE_URL + "grupos";
  await HTTP.get(url).then((response) => {
    // Orden personalizado: primero los que empiezan por E (EXY), luego B (BXY), luego resto por nombre.
    const prioridad = (nombre) => {
      const upper = (nombre || "").toUpperCase();
      if (upper.startsWith("E")) return 0;
      if (upper.startsWith("B")) return 1;
      return 2;
    };

    GRUPOS = response.data
      ?.slice()
      .sort((a, b) => {
        const pa = prioridad(a.nombre);
        const pb = prioridad(b.nombre);
        if (pa !== pb) return pa - pb;
        return a.nombre.localeCompare(b.nombre, "es", { sensitivity: "base" });
      });
  });
} 

export function getGrupos(setGrupos) {
  // Enviamos una copia para evitar mutaciones externas
  setGrupos(GRUPOS?.slice() || []);
}
